// src/components/DoubleImageSection.js
import React from "react";
import "./DoubleImageSection.css";
import img1 from "../assets/m5.jpg";
import img2 from "../assets/m6.jpg";

const DoubleImageSection = () => {
  return (
    <section className="double-image-section">
      <div className="image-top">
        <img src={img1} alt="First view" className="double-img" />
      </div>

      <div className="image-spacing"></div>

      <div className="image-bottom">
        <img src={img2} alt="Second view" className="double-img" />
      </div>
    </section>
  );
};

export default DoubleImageSection;
